module.exports = __webpack_public_path__ + "assets/img/logo-disaster-mind.a4a23f84.png";